export default __webpack_public_path__ + "static/media/cocoa-beans.2601dd64.jpg";